/* Joins the non-empty parts, with a different separator before the last one if given. */
export const joinParts = (
  parts: Array<string | null | undefined | false>,
  separator = ' - ',
  lastSeparator = separator,
): string => {
  const strings = parts.filter((part): part is string => !!part && part.length > 0);
  if (!strings.length) {
    return '';
  }
  if (strings.length === 1) {
    return strings[0];
  }
  return strings.slice(0, -1).join(separator) + lastSeparator + strings[strings.length - 1];
};
